import { ElementRef } from '@angular/core';
import { z } from 'zod';

export interface IIqMcLtGraphParams {
    id?: string;
    direction: string;
    equipmentType: string;
    geoType: string;
    geoCode?: string;
}

export interface IIqLoadTruckResponse {
    data: number;
    date: string;
}

export interface IIqLoadTruckData {
    data: IIqLoadTruckResponse[];
    errors?: boolean;
    loaded?: boolean;
}

export interface graphProps {
    strokeColor?: string;
}

export interface IIqGraphLtStateService {
    renderLoadsGraph(
        container: ElementRef<any>,
        loadsData: IIqLoadTruckData,
    ): void;

    renderTrucksGraph(
        container: ElementRef<any>,
        trucksData: IIqLoadTruckData,
    ): void;

    getLoadsData(params: IIqMcLtGraphParams): Promise<IIqLoadTruckData>;
    getTruckData(params: IIqMcLtGraphParams): Promise<IIqLoadTruckData>;
}

export const IIqLoadsResponseSchema = z.object({
    data: z.object({
        loadTruck: z.array(
            z.object({
                geoCode: z.string(),
                date: z.string(),
                loads: z.number(),
            }),
        ),
    }),
    loading: z.boolean(),
});

export const IIqTrucksResponseSchema = z.object({
    data: z.object({
        loadTruck: z.array(
            z.object({
                geoCode: z.string(),
                date: z.string(),
                trucks: z.number(),
            }),
        ),
    }),
    loading: z.boolean(),
});

export type IIqLoadsResponse = z.infer<typeof IIqLoadsResponseSchema>;
export type IIqTrucksResponse = z.infer<typeof IIqTrucksResponseSchema>;

export const emptyIqLoadsResponse: IIqLoadsResponse = {
    data: {
        loadTruck: [],
    },
    loading: true,
};

export const emptyIIqLoadTruckResponse: IIqLoadTruckResponse = {
    data: 0,
    date: '',
};

export const emptyIqLoadTruckData: IIqLoadTruckData = {
    data: [emptyIIqLoadTruckResponse],
    errors: false,
    loaded: false,
};
